module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_save-21119d6f51d553c791e88fa80095e2b3.png";